import React from 'react';
import { omit } from 'lodash';
import PropTypes from 'prop-types';
import { createLocalNucleusForm, createReduxNucleusForm, nucleusFormShape } from '../NucleusForm';
import storeShape from '../utils/storeShape';
export const wrapWithReduxFormProvider = (formId, formSelector) => WrappedComponent => {
    var _a;
    return _a = class FormProvider extends React.Component {
            constructor(props, context) {
                super(props, context);
                const store = props.store || context.store;
                if (formSelector && !store) {
                    throw new Error('Could not find "store" in either the context or props of ' + '"Form". Either wrap the root component in a <Provider>, ' + 'or explicitly pass "store" as a prop to "Form".');
                }
                this.nucleusForm = formSelector ? createReduxNucleusForm(formId, store, formSelector) : context.nucleusForm || props.nucleusForm || createLocalNucleusForm('LocalForm');
            }
            getChildContext() {
                return {
                    nucleusForm: this.nucleusForm
                };
            }
            render() {
                return React.createElement(WrappedComponent, Object.assign({}, omit(this.props, ['nucleusForm'])), this.props.children);
            }
        },
        _a.displayName = 'FormProvider',
        _a.contextTypes = {
            nucleusForm: nucleusFormShape,
            store: storeShape
        },
        _a.childContextTypes = {
            nucleusForm: nucleusFormShape
        },
        _a.propTypes = {
            nucleusForm: nucleusFormShape,
            store: storeShape,
            children: PropTypes.node
        },
        _a;
};
const wrapWithLocalFormProvider = wrapWithReduxFormProvider();
export default wrapWithLocalFormProvider;
